export const isEmptyObject = (object: any): boolean => {
  return Object.keys(object).length > 0;
};
